import styled from "@emotion/styled";
import type { FunctionComponent } from "react";

import {
  useContentsByTopicsByIds,
  useInlinePlusWidget,
} from "scmp-app/components/schema-render/common/inline-plus-widget/hooks";
import { Container } from "scmp-app/components/schema-render/common/inline-plus-widget/styles";
import type { hooksInlinePlusWidgetContent$key } from "scmp-app/queries/__generated__/hooksInlinePlusWidgetContent.graphql";

import { InlinePlusWidgetSubscriber } from "./subscriber";

type Props = {
  reference?: hooksInlinePlusWidgetContent$key;
};

const Component: FunctionComponent<Props> = ({ reference }) => {
  const { topicIds } = useInlinePlusWidget(reference);
  const { articleIds, contentsReference } = useContentsByTopicsByIds(topicIds);

  return (
    <Container>
      <InlinePlusWidgetSubscriber articleIds={articleIds} reference={contentsReference} />
    </Container>
  );
};

Component.displayName = "InlinePlusWidgetContents";

export const InlinePlusWidgetContents = styled(Component)``;
